import { FC, useEffect, useRef } from "react";
import { StringParam, useQueryParams } from "use-query-params";
import { getApiErrorStatus } from "@api/apiError";
import { useAcceptOrgBillingTransferMutation } from "@api/orgBillingTransferRecipient.api";
import { PageCoverLoader } from "@design-system/PageCoverLoader/PageCoverLoader";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { useStateAwareNavigate } from "@hooks/useStateAwareNavigate";
import {
    SAVE_PAYMENT_METHOD_ERROR,
    toInAppPath,
} from "./orgBillingTransferReturn.lib";

export const AcceptOrgBillingTransferReturn: FC = () => {
    const navigate = useStateAwareNavigate();
    const { success, error: showError } = useToaster();
    const accept = useAcceptOrgBillingTransferMutation();
    const hasStartedRef = useRef(false);
    const [params] = useQueryParams({
        requestId: StringParam,
        after: StringParam,
        setup_intent: StringParam,
        redirect_status: StringParam,
    });

    useEffect(() => {
        if (hasStartedRef.current) {
            return;
        }
        hasStartedRef.current = true;

        const after = toInAppPath(params.after);
        const { requestId, setup_intent: intentId } = params;

        if (!requestId || !intentId || params.redirect_status === "failed") {
            showError(SAVE_PAYMENT_METHOD_ERROR);
            navigate(after, { replace: true });
            return;
        }

        accept.mutate(
            { requestId, intentId },
            {
                onSuccess: () => {
                    success("Billing transfer accepted");
                    navigate(after, { replace: true });
                },
                onError: (error) => {
                    if (getApiErrorStatus(error) === undefined) {
                        showError("Failed to accept billing transfer");
                    }
                    navigate(after, { replace: true });
                },
            },
        );
    }, [accept, navigate, params, showError, success]);

    return <PageCoverLoader>Saving payment details</PageCoverLoader>;
};
